import { Dialog, DialogTitle, makeStyles, Tooltip, MenuItem, TextField, Checkbox, Popover, DialogContent } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DriverTable from "./DriverTable";
import { useDispatch, useSelector } from "react-redux";
import { getDeliveryAreas, getIndividual, getReviewCount, getVehicleTypes } from "../../../actions/driverAppApprovalActions";
import { getUserPreference } from "../../../utilities/common";
import { showAlertSnackbar } from "../../../reducers/uiSlice";

const useStyles = makeStyles((theme) => ({
    titleText: {
        fontSize: 16,
        color: '#dd4b3f'
    },
    inputBase: {
        border: '1px solid #6e6e6e',
        display: 'flex',
        alignItems: 'center',
        width: 400
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 8,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    formControl: {
        width: 160
    },
    popper: {
        padding: 19,
        border: 'solid 1px #ff9d00',
        backgroundColor: '#262626',
        borderRadius: 2
    },
    content: {
        flexGrow: 1,
        height: 781
    }
}))

function DriverApplicationsModal(props) {
    const {t} = useTranslation('driverApproval');
    const classes = useStyles();
    const dispatch = useDispatch();
    const userPref = getUserPreference()

    const stateList = [0, 1, 8, 2, 9];

    const [openModal, setOpenModal] = useState(false);
    const [applicationNum, setApplicationNum] = useState(0);
    const [checkbox, setCheckbox] = useState([true, true, true, true, true]);
    const [type, setType] = useState(1);
    const [states, setStates] = useState('');
    const [input, setInput] = useState('');

    function handleClose() {
        setOpenModal(false);
        props.handleClose();
    }
    function toggleCheckbox(index) {
        let checkboxCopy = JSON.parse(JSON.stringify(checkbox));
        if(index === 0) {
            checkboxCopy.map((v, i) => {
                checkboxCopy[i] = !checkbox[index];
            })
        } else {
            checkboxCopy[index] = !checkbox[index];
        }
        if(checkboxCopy[1] && checkboxCopy[2] && checkboxCopy[3] && checkboxCopy[4]) {
            checkboxCopy[0] = true;
        } else {
            checkboxCopy[0] = false;
        }
        setCheckbox(checkboxCopy);
    }
    function CustomizedInputBase() {
        const classes = useStyles();
        
        const [anchorEl, setAnchorEl] = useState(null);

        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        const open = Boolean(anchorEl);
        const id = open ? 'simple-popover' : undefined;

        function handleSearch() {
            let statesCurr = '';
            checkbox.map((state, index) => {
                if(state && index) {
                    statesCurr += ',' + stateList[index];
                }
            })
            statesCurr = statesCurr.substring(1);
            setStates(statesCurr);
            if(type === 1) {
                dispatch(getIndividual(30, 1, 10, input, '', statesCurr, userPref.userCity))
            } else if(type === 2) {
                dispatch(getIndividual(30, 1, 10, '', input, statesCurr, userPref.userCity))
            }
            setInput('');
        }

        return (
            <Paper className={classes.inputBase}>
                <TextField
                    select
                    defaultValue={1}
                    variant="outlined"
                    size="small"
                    value={type}
                    onChange={(event)=>{setType(event.target.value)}}
                >
                    <MenuItem value={1}>{t('driver_id')}</MenuItem>
                    <MenuItem value={2}>{t('phone_number')}</MenuItem>
                </TextField>
                <InputBase
                    className={classes.input}
                    variant="outlined"
                    size="small"
                    value={input}
                    autoFocus
                    onChange={(e) => setInput(e.target.value)}
                />
                    <div>
                        <IconButton className={classes.iconButton} aria-describedby={id} onClick={handleClick}>
                            <FilterListIcon />
                        </IconButton>
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                        >
                            <Paper>
                                <div className={classes.popper}>
                                    {/* <div>
                                        <Checkbox 
                                            color='primary' 
                                            checked={checkbox[0]}
                                            onClick={(e)=>{
                                                e.preventDefault();
                                                toggleCheckbox(0);
                                            }}
                                        />
                                        <span>{t('all_applications')}</span>
                                    </div> */}
                                    <div style={{paddingTop: 9, display: 'flex', paddingRight: 8}}>
                                        <div>
                                            <Checkbox 
                                                color='primary' 
                                                checked={checkbox[1]} 
                                                disabled
                                            />
                                            <span>{t('new')}</span>
                                        </div>
                                        <div>
                                            <Checkbox 
                                                color='primary' 
                                                checked={checkbox[2]} 
                                                onClick={(e)=>{
                                                    toggleCheckbox(2)
                                                }}
                                            />
                                            <span>{t('approved')}</span>
                                        </div>
                                        <div>
                                            <Checkbox 
                                                color='primary' 
                                                checked={checkbox[3]} 
                                                onClick={(e)=>{
                                                    toggleCheckbox(3)
                                                }}
                                            />
                                            <span>{t('pending')}</span>
                                        </div>
                                        <div>
                                            <Checkbox 
                                                color='primary' 
                                                checked={checkbox[4]} 
                                                onClick={(e)=>{
                                                    toggleCheckbox(4)
                                                }}
                                            />
                                            <span>{t('rejected')}</span>
                                        </div>
                                    </div>
                                </div>
                            </Paper>
                        </Popover>
                    </div>
                <Divider className={classes.divider} orientation="vertical" />
                <IconButton 
                    color="primary" 
                    className={classes.iconButton} aria-label="directions"
                    onClick={handleSearch}
                >
                    <SearchIcon />
                </IconButton>                
            </Paper>
        );
    }
    function handleUpdateApplicationNum() {
        dispatch(getReviewCount(userPref.userCity))
        .then((res) => {
            setApplicationNum(res.count);
        })
        .catch((err) => {
            setApplicationNum(0);
            dispatch(showAlertSnackbar({message: t('fetch_error'), type: 'error'}))
        })
    }

    useEffect(() => {
        setOpenModal(props.open);
        if(props.open) {
            handleUpdateApplicationNum();
            dispatch(getIndividual(30, 1, 10, '', '', '', userPref.userCity));
            setCheckbox([true, true, true, true, true]);
            dispatch(getVehicleTypes());
        }
    }, [props.open])

    return (
        <Dialog
            open={openModal}
            onClose={handleClose}
            maxWidth='lg'
            fullWidth
        >
            <DialogTitle>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div style={{display: 'flex', alignItems: 'baseline'}}>
                        <span>{t('driver_applications')}</span>
                        <span
                            className={classes.titleText}
                            style={{
                                marginLeft: 33
                            }}
                        >
                            {applicationNum} {t('number')}
                        </span>
                        <div style={{marginLeft: 200}}>
                            <CustomizedInputBase />
                        </div>
                        
                    </div>
                    <Tooltip title={t('common:cancel')} aria-label="cancel">
                        <CloseIcon onClick={handleClose}></CloseIcon>
                    </Tooltip>
                </div>
            </DialogTitle>
            <DialogContent dividers  className={classes.content}>
                <DriverTable type={type} input={input} states={states} handleUpdate={handleUpdateApplicationNum}/>
            </DialogContent>
        </Dialog>
    );
}
export default DriverApplicationsModal;